import React from 'react';
import { useTranslation } from 'react-i18next';
import { PastDueCustomerResponse } from '../../domain/PastDueList/PastDueCustomerList';
import { CustomerBreadcrumb } from './CustomerBreadcrumb';
import { CustomerDetailsProvider } from '../../context/CustomerDetails/CustomerDetailsProvider';
import { CustomerDetails } from './CustomerDetails/CustomerDetails';
import { Redirect, useLocation } from 'react-router-dom';
import { CustomerLocationState } from '../../types/types';
import { AppRoute } from '../../config/route-config';
import { NotesProvider } from '../../context/Notes/NotesProvider';

export interface CustomerProps {
  customer?: PastDueCustomerResponse;
}
export const Customer = () => {
  const Translate: any = useTranslation();
  const location = useLocation<CustomerLocationState>();

  const customerId = location?.pathname?.split('/')[3];

  if (!location?.state?.customer?.customerId && !customerId) {
    return <Redirect to={AppRoute.PastDueList} />;
  }
  return (
    <NotesProvider>
      <CustomerDetailsProvider {...Translate}>
        <CustomerBreadcrumb />
        <CustomerDetails />
      </CustomerDetailsProvider>
    </NotesProvider>
  );
};
